// extracted by mini-css-extract-plugin
export default {"slider":"Login_slider__EhAS3","slide":"Login_slide__wLVY7","flexSlides":"Login_flexSlides__FV2b8","move":"Login_move__SELPS"};